import React from "react";
//#region types
import { ReceiptUploadedByProps } from "models/propTypes/receiptPropTypes";
import { TranslationKeys } from "translations";
import { FormFieldConstants } from "utils/constants";
//#endregion
//#region components
import { Grid } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
//#endregion
import { LocalizationHelperInstance, UrlHelper } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";

const ReceiptUploadedBy: React.FC<ReceiptUploadedByProps> = (props) => {
  const navigate = useNavigate();
  const location = useLocation();

  const onClick = (e?: React.MouseEvent) => {
    if (props.personId) e?.stopPropagation();

    props.personId &&
      props.personName &&
      navigate(
        UrlHelper.formatPath(
          `/Reports/Expenses/Receipts?${FormFieldConstants.Receipt.Filter.UploadedByUsers}Ids=${props.personId}&${FormFieldConstants.Receipt.Filter.UploadedByUsers}Names=${props.personName}`
        ),
        { state: { background: location } }
      );
  };

  return (
    <Grid container direction="row" columnGap="3px">
      <Grid item>{`${LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.SubmittedBy)} : `}</Grid>
      <Grid item className={clsx(cssExports.personName, cssExports.truncateString)}>
        <span className={cssExports.titleLink} onClick={onClick}>
          {props.personName}
        </span>
      </Grid>
    </Grid>
  );
};

export default ReceiptUploadedBy;
